"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validationErrorKeys = exports.validationErrorDefaultCaptions = exports.otherDefaultCaptions = exports.otherCaptionKeys = exports.SETTINGS = exports.CONDITIONAL_OPERATORS = exports.CONDITIONAL_CONJUNCTIONS = void 0;
var SETTINGS = exports.SETTINGS = {
  questionsInOrder: 'questionsInOrder',
  oneQuestionAtATime: 'oneQuestionAtATime',
  displayQuestionsInPages: 'displayQuestionsInPages',
  backwardMovement: 'backwardMovement',
  duration: 4
};
var CONDITIONAL_OPERATORS = exports.CONDITIONAL_OPERATORS = {
  EQUALS: '=',
  NOT_EQUALS: '<>'
};
var CONDITIONAL_CONJUNCTIONS = exports.CONDITIONAL_CONJUNCTIONS = {
  AND: 'and',
  OR: 'or'
};

// these are the caption keys for the intl strings
var otherCaptionKeys = exports.otherCaptionKeys = {
  confirmOrder: "SurveyWidgets.StackRank.confirmOrder",
  allocated: "SurveyWidgets.ConstantSum.allocated",
  total: "SurveyWidgets.ConstantSum.total",
  selectValue: "SurveyDetails.selectValue",
  enterText: "SurveyDetails.enterText",
  enterValue: "SurveyDetails.enterValue",
  otherText: "SurveyDetails.otherText"
};
var otherDefaultCaptions = exports.otherDefaultCaptions = {
  confirmOrder: "Confirm order after ranking all answers",
  allocated: "allocated",
  total: "Total",
  selectValue: "Select...",
  enterText: "Enter text",
  enterValue: "Enter value",
  otherText: "Other (describe)"
};

// these are the caption keys for the intl strings
var validationErrorKeys = exports.validationErrorKeys = {
  answerRequired: "SurveyDetails.answerRequired",
  otherValueRequired: "SurveyDetails.otherValueRequired",
  totalCannotExceed: "SurveyWidgets.ConstantSum.totalCannotExceed",
  sumMustEqual: "SurveyWidgets.ConstantSum.sumMustEqual",
  minimumInputRange: "SurveyWidgets.ConstantSum.minimumInputRange",
  maximumInputRange: "SurveyWidgets.ConstantSum.maximumInputRange",
  minAndMaxInputRange: "SurveyWidgets.ConstantSum.minAndMaxInputRange",
  answerAllRequired: "SurveyDetails.answerAllRequired",
  requiredQuestionIndicator: "SurveyDetails.requiredQuestionIndicator"
};
var validationErrorDefaultCaptions = exports.validationErrorDefaultCaptions = {
  answerRequired: "Please answer the question.",
  otherValueRequired: "Please enter the other value.",
  totalCannotExceed: "The total cannot exceed TARGET_SUM.",
  sumMustEqual: "The sum of all values must equal TARGET_SUM.",
  minimumInputRange: "Values must have a minimum of MINIMUM_INPUT.",
  maximumInputRange: "Values may have a maximum of MAXIMUM_INPUT.",
  minAndMaxInputRange: "Values must be between MINIMUM_INPUT and MAXIMUM_INPUT.",
  answerAllRequired: "Please answer all required questions.",
  requiredQuestionIndicator: "Required question"
};